var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import theme from '../../../theme';
export var DisputesDetailsTitle = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n  padding-bottom: ", "px;\n  font-weight: ", ";\n  border-bottom: 1px solid ", ";\n"], ["\n  font-size: ", "px;\n  padding-bottom: ", "px;\n  font-weight: ", ";\n  border-bottom: 1px solid ", ";\n"])), fontSizes.medium, spacing.small, fontWeights.light, theme.colors.lightGrey);
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map